export default __webpack_public_path__ + "static/media/CV_FORMAT.1d5fe0f2.pdf";